import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_listen.svg';
import Icon, { IconProps } from './icon';

const IconListen = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconListen;
